import { useEffect, useState } from "react";
import { PageTable, Header } from "/src/layouts/page";
import SliderTab from "/src/components/slider/sliderTab";
import TelephonyLogsTable from "./TelephonyLogsTable/TelephonyLogsTable";
import PhoneCapacityTable from "./PhoneCapacityTable/PhoneCapacityTable";
import "../TelephonyLogs.css";

const REFRESH_INTERVAL_MS = 10000;

function TelephonyLogsPage() {
    const [refreshLogs, setRefreshLogs] = useState(false);
    const [refreshCapacity, setRefreshCapacity] = useState(false);
    const [lastRefreshedAt, setLastRefreshedAt] = useState(Date.now());
    const [secondsAgo, setSecondsAgo] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setRefreshLogs((tick) => !tick);
            setRefreshCapacity((tick) => !tick);
            setLastRefreshedAt(Date.now());
        }, REFRESH_INTERVAL_MS);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const tick = setInterval(() => {
            setSecondsAgo(Math.floor((Date.now() - lastRefreshedAt) / 1000));
        }, 1000);

        return () => clearInterval(tick);
    }, [lastRefreshedAt]);

    const items = [
        { name: "Logs", component: <TelephonyLogsTable refreshState={[refreshLogs, setRefreshLogs]} /> },
        { name: "Phones", component: <PhoneCapacityTable refreshState={[refreshCapacity, setRefreshCapacity]} /> },
    ];

    return (
        <PageTable>
            <Header title="Telephony Logs">
                <span className="telephony-log-refresh-pill" title="Auto-refreshes every 10s">
                    <span className="telephony-log-refresh-dot"></span>
                    Last refreshed {secondsAgo}s ago
                </span>
            </Header>
            <div className="telephony-logs-page">
                <SliderTab items={items} name="telephony-logs" type="tab" />
            </div>
        </PageTable>
    );
}

export default TelephonyLogsPage;
